/*
 * av-mag-search.js
 * ---------------------------------------------------------------------------
 * Suche im Magazin.
 *
 * Das Formular funktioniert ohne JavaScript und führt dann auf die
 * Suchergebnisseite. Ist das Skript da, holt es dieselbe Sektion über die
 * Section Rendering API (?q=…&type=article&section_id=…) und setzt die Treffer
 * an Ort und Stelle ein — der Leser bleibt im Magazin.
 *
 * Solange eine Suche läuft, treten Featured, Rhythm und Archiv zurück; ohne
 * Begriff steht die Übersicht wieder wie vorher da.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var DEBOUNCE = 300;
  var MIN_CHARS = 2;
  var ACTIVE = 'av-mag-searching';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function setup(root) {
    var form = root.querySelector('[data-av-mag-search-form]');
    var input = root.querySelector('[data-av-mag-search-input]');
    var results = root.querySelector('[data-av-mag-search-results]');
    var clear = root.querySelector('[data-av-mag-search-clear]');
    var sectionId = root.getAttribute('data-section-id');
    var searchUrl = root.getAttribute('data-search-url') || '/search';

    if (!form || !input || !results || !sectionId) return;

    var timer = null;
    var current = null;
    var lastTerm = null;

    function url(term) {
      var u = new URL(searchUrl, window.location.origin);
      u.searchParams.set('q', term);
      u.searchParams.set('type', 'article');
      u.searchParams.set('options[prefix]', 'last');
      u.searchParams.set('section_id', sectionId);
      return u.toString();
    }

    function reset() {
      lastTerm = null;
      results.innerHTML = '';
      results.hidden = true;
      if (clear) clear.hidden = true;
      document.body.classList.remove(ACTIVE);
    }

    function show(html) {
      results.innerHTML = html;
      results.hidden = false;
      if (clear) clear.hidden = false;
      document.body.classList.add(ACTIVE);
    }

    function run(term) {
      if (term === lastTerm) return;
      lastTerm = term;

      /* Eine ältere Anfrage darf eine neuere nicht überholen. */
      if (current) current.abort();
      var controller = new AbortController();
      current = controller;

      root.setAttribute('data-av-busy', 'true');

      fetch(url(term), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        signal: controller.signal
      })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var incoming = doc.querySelector('[data-av-mag-search-results]');
          if (!incoming) throw new Error('Keine Treffer im Fragment');
          show(incoming.innerHTML);
        })
        .catch(function (error) {
          if (error.name === 'AbortError') return;
          console.warn('[av-mag-search] Suche fehlgeschlagen:', error);
          /* Im Zweifel bleibt der klassische Weg: Formular abschicken. */
          lastTerm = null;
        })
        .then(function () {
          root.removeAttribute('data-av-busy');
        });
    }

    function handle() {
      var term = input.value.trim();

      window.clearTimeout(timer);

      if (term.length < MIN_CHARS) {
        if (current) current.abort();
        reset();
        return;
      }

      timer = window.setTimeout(function () {
        run(term);
      }, DEBOUNCE);
    }

    input.addEventListener('input', handle);

    form.addEventListener('submit', function (event) {
      var term = input.value.trim();
      if (term.length < MIN_CHARS) return;
      /* Kein Seitenwechsel — die Treffer stehen schon hier. */
      event.preventDefault();
      window.clearTimeout(timer);
      run(term);
    });

    if (clear) {
      clear.addEventListener('click', function () {
        input.value = '';
        input.focus();
        if (current) current.abort();
        window.clearTimeout(timer);
        reset();
      });
    }

    /* Mit ?q=… im Aufruf stehen die Treffer schon serverseitig drin. */
    if (!results.hidden && results.innerHTML.trim() !== '') {
      lastTerm = input.value.trim();
      if (clear) clear.hidden = false;
      document.body.classList.add(ACTIVE);
    }
  }

  ready(function () {
    Array.prototype.slice
      .call(document.querySelectorAll('[data-av-mag-search]'))
      .forEach(setup);
  });

  /* Der Theme-Editor tauscht Sektionen im laufenden Betrieb aus. */
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-av-mag-search]');
    if (root) setup(root);
  });
})();
